import PropTypes from 'prop-types';
import { Component } from 'react';
import { NavMarker } from 'react-rhumb';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import devLogger from 'react-utils/devLogger';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info) {
    devLogger.warn({
      message: 'Error boundary triggered',
      key: null
    });
    devLogger.warn({
      message: error,
      key: null
    });
    devLogger.warn({
      message: info,
      key: null
    });
    this.setState({
      hasError: true
    });
  }
  render() {
    const {
      children
    } = this.props;
    const {
      hasError
    } = this.state;
    if (!hasError) {
      return children;
    }
    return /*#__PURE__*/_jsxs(UIErrorMessage, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "UP_FRONT_REQUEST_ERROR"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.errors.renderError"
      })]
    });
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};